export class PackageBuilderConstants {
  public static WHEELS_ROUTE = 'wheels';
  public static TIRES_ROUTE = 'tires';
  public static HARDWARES_ROUTE = 'hardwares';
  public static SUMMARY_ROUTE = 'summary';
  public static PACKAGEKITS_ROUTE = 'packagekits';
}
